"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  control: function control(styles, state) {
    return __assign(__assign({}, styles), {
      backgroundColor: 'white',
      borderColor: state.isFocused ? '#030f40' : '#E7E8EE',
      borderRadius: '2px',
      minHeight: '48px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#030f40'
      }
    });
  },
  menu: function menu(styles) {
    return __assign(__assign({}, styles), {
      zIndex: 3
    });
  },
  menuList: function menuList() {
    return {
      padding: 0,
      backgroundColor: '#ffffff'
    };
  },
  option: function option(provided, state) {
    return __assign(__assign({}, provided), {
      fontWeight: state.isSelected ? 'bold' : 'normal',
      padding: 10,
      backgroundColor: state.isSelected && '#F4F8FF',
      color: state.isSelected && '#030f40',
      '&:hover': {
        backgroundColor: '#FCFCFC'
      }
    });
  },
  dropdownIndicator: function dropdownIndicator(styles) {
    return __assign(__assign({}, styles), {
      color: '#030f40',
      '&:hover': {
        color: '#030f40'
      }
    });
  },
  indicatorSeparator: function indicatorSeparator(styles) {
    return __assign(__assign({}, styles), {
      backgroundColor: 'transparent'
    });
  },
  input: function input(styles) {
    return __assign({}, styles);
  },
  placeholder: function placeholder(styles) {
    return __assign({}, styles);
  },
  singleValue: function singleValue(styles, _a) {
    var data = _a.data;
    return __assign({}, styles);
  }
};